export const initStateConcepts = (
   Object.assign({
      data            : [],
      concept_spanish : '',
      concept_english : '',
      amount          : 0,
      actionForm      : false,
      conceptId       : ''
   })
);